import { useEffect, useState } from 'react';
import { getRecaptchaSiteKey } from '../veevaIdApi';
import ResponseStatus from '../constants/ResponseStatus';
import ErrorPageErrorTypes from '../constants/ErrorPageErrorTypes';

const useRecaptchaSiteKey = () => {
    const [siteKey, setSiteKey] = useState(null);
    const [error, setError] = useState();

    useEffect(() => {
        getRecaptchaSiteKey().then((response) => {
            switch (response.responseStatus) {
                case ResponseStatus.SUCCESS: {
                    setSiteKey(response.data);
                    break;
                }
                case ResponseStatus.FAILURE: {
                    const recaptchaError = {
                        ...response.errors[0],
                        type: ErrorPageErrorTypes.FAILED_TO_LOAD,
                    };
                    setError(recaptchaError);
                    break;
                }
                case ResponseStatus.UI_NETWORK_ERROR: {
                    setError({ type: ErrorPageErrorTypes.FAILED_TO_LOAD });
                    break;
                }
                default:
                // No-op
            }
        });
    }, []);

    return [siteKey, error];
};

export default useRecaptchaSiteKey;
